"use client"

import { FiCheckCircle } from "react-icons/fi"
import { motion } from "framer-motion"
import { containerVariants, iconVariants, itemVariants } from "./motion"
import { useNavigate } from "react-router-dom";

export default function PaymentComplete({setStep}) {
  const navigate = useNavigate();
  return (
    <motion.div
      className="border border-[#CAC3BB] rounded-lg shadow-custom p-12 w-full max-w-md text-center"
      initial="hidden"
      animate="visible"
      variants={containerVariants}
    >
      <motion.div
        className="w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4"
        variants={iconVariants}
      >
        <FiCheckCircle className="h-16 w-16 text-[#036494]" />
      </motion.div>

      <motion.h2 className="text-xl mb-6" variants={itemVariants}>
        Verification done
      </motion.h2>

      <motion.div variants={itemVariants} whileHover={{ scale: 1.02 }} whileTap={{ scale: 0.98 }}>
        <button
          onClick={()=>navigate("/login")}
          className="w-full bg-[#036494] text-white py-2 rounded-full hover:bg-[#075985] transition-colors"
        >
          Proceed to Profile
        </button>
      </motion.div>
    </motion.div>
  )
}

